// extracted by mini-css-extract-plugin
module.exports = {"window":"window_window__271Lk","open":"window_open__3ofri","bg":"window_bg__39vYv","container":"window_container__IhmQi","inner":"window_inner__2Purt"};